import styled from "styled-components/macro";

export const SettingsTopLine = styled.div`
  background: var(--clr-settingstopbar);
  color: #edebeb;
  text-align: center;
  padding: 0.2em;
  position: relative;
`;

export const SettingsBack1 = styled.div`
  color: #edebeb;
  position: absolute;
  top: 10%;
  left: 0;
  cursor: pointer;
`;

export const SettingsClose = styled.div`
  color: #edebeb;
  position: absolute;
  top: 10%;
  right: 0;
`;
